import { Component, inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ShopSection, ShopSettings } from '@infrab4a/connect';
import { MessageService } from 'primeng/api';
import { ShopSettingsService } from 'src/app/connect-api/api/shop-settings/shop-settings.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-live-form',
  templateUrl: './live-form.component.html',
  styleUrl: './live-form.component.scss'
})
export class LiveFormComponent implements OnInit {
  @Input() id: string | null = null;
  form: FormGroup;
  settings: Partial<ShopSettings> & { sections?: ShopSection[] };
  private messageService = inject(MessageService);
  private shopSettingsService = inject(ShopSettingsService);

  constructor(
    private fb: FormBuilder,
    readonly router: Router,
    readonly activatedRoute: ActivatedRoute
  ) {
    this.form = this.fb.group({
      id: [''],
      type: ['LIVE'],
      fixed: [false],
      editable: [true],
      title: ['', Validators.required],
      link: ['', Validators.required],
      active: [true]
    });
  }

  async ngOnInit(): Promise<void> {
    this.settings = await this.shopSettingsService.getById('GLAM_NEW_HOME');
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    if (this.id) {
      // Edit mode: Load existing section data
      const section = this.settings.sections?.find((s) => s.id === this.id);
      // Populate form with existing data
      if (section) {
        this.form.patchValue({ id: this.id, ...section });
      }
    }

    console.log('this.settings', this.settings);
  }

  async onSubmit(): Promise<void> {
    if (this.form.valid) {
      LoaderService.showLoader();
      const newSection = this.getLiveData();
      const sections = this.settings.sections || [];
      const existingIndex = sections.findIndex((s) => s.id === this.id);

      if (existingIndex >= 0) {
        sections[existingIndex] = newSection;
      } else {
        sections.push(newSection);
      }

      await this.shopSettingsService.update({
        id: this.settings.id,
        sections: sections
      });
    }
    LoaderService.showLoader(false);
    this.messageService.add({
      severity: 'success',
      summary: 'Sucesso',
      detail: 'Live salva com sucesso'
    });

    this.router.navigate(['/configuracoes/glam/new-home']);
  }

  private getLiveData() {
    const formValue = this.form.value;
    return {
      id: formValue.id || crypto.randomUUID(),
      type: formValue.type,
      fixed: formValue.fixed,
      editable: formValue.editable,
      title: formValue.title,
      link: formValue.link,
      active: formValue.active
    };
  }
}
